export default (function (node) {
  return node.nodeName && node.nodeName.toLowerCase();
});